import { render, staticRenderFns } from "./level.vue?vue&type=template&id=1944b924&"
import script from "./level.vue?vue&type=script&lang=js&"
export * from "./level.vue?vue&type=script&lang=js&"
import style0 from "./level.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports